import * as React from "react";
import {Icon} from "../../../hiberUiKit/src/atoms/Icon/Icon";
import DropDown from "../../../hiberUiKit/src/molecules/DropDown/DropDown";
import InfoModule from "../../../hiberUiKit/src/molecules/InfoModule/InfoModule";
import {none, option, Option} from "ts-option";

interface ComponentProps {
	/**
	 * Update custom field value action.
	 * @param {string} updatedValue
	 */
	updateCustomFieldValue: (updatedValue: string) => void;
	/**
	 * Remove custom field value action.
	 */
	removeCustomFieldValue: () => void;
	/**
	 * Custom field label
	 */
	label: string;
	/**
	 * Selected custom field value
	 */
	selectedValue: Option<string>;
}

export default class BooleanDisplay extends React.PureComponent<ComponentProps> {
	render() {
		return (
			<InfoModule icon={Icon.New} title={this.props.label}>
				<DropDown items={[YesNo.YES, YesNo.NO]}
						  itemToId={(item: string) => item}
						  itemToLabel={(item: string) => item}
						  selectedItemId={this.getSelectedItem().orNull}
						  placeholder={'Please select'}
						  onSelect={this.onSelect}
						  clearable
						  onClearClick={this.onClearClick}/>
			</InfoModule>
		)
	}

	onSelect = (value: string) => {
		this.props.updateCustomFieldValue(value);
	};

	onClearClick = () => {
		this.props.removeCustomFieldValue();
	};

	getSelectedItem() {
		return this.props.selectedValue.flatMap(sv => {
			if (sv === YesNo.YES) {
				return option(YesNo.YES);
			}
			else if (sv === YesNo.NO) {
				return option(YesNo.NO);
			}
			return none;
		})
	}
}

export enum YesNo {
	YES = 'Yes',
	NO = 'No'
}